import { useEffect, useState } from "react";
import ChatComponent from "../../../../component/chatComponent";
import { useSnackbar } from "../../../../component/SnackbarContext";
import axiosInstance from "../../../../configuration/request";

export default function ChatWithDelivery({ onClose ,pickupId }) {
  const [messages, setMessages] = useState([]);
  const showSnackbar = useSnackbar();
  useEffect(() => {
    fetchOrdersChat();
    const interval = setInterval(() => {
      fetchOrdersChat();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const fetchOrdersChat = () => {
    axiosInstance
      .get(`/customer/chat/messages?pickupId=${pickupId}`, { skipLoader: true })
      .then((res) => {
        const mapped =
          res?.data
            ?.map((msg) => ({
              sender: msg.senderRole === "customer" ? "sender" : "receiver",
              chatType: "customer",
              text: msg.message,
              senderRole:msg.senderRole,
              relatedMismatch: msg?.relatedMismatch,
              time: new Date(msg.createdAt).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              }),
              onDecision: handleDecision,
            }))
            .reverse() || [];
        setMessages(mapped);
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      });
  };

  const addMessage = (chatMessage) => {
    const now = new Date();
    const newMsg = {
      sender: "sender",
      text: chatMessage,
      time: now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };
    setMessages((prev) => [...prev, newMsg]);

    let payload = {
      pickupId: pickupId,
      senderRole: "customer",
      messageType: "text",
      message: chatMessage,
    };
    axiosInstance
      .post(`/customer/chat/message`, payload, { skipLoader: true })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      });
  };

  const handleDecision = (decision, mismatch) => {
    let payload = {
      decision: "accepted",
    };
    
    axiosInstance
      .patch(`/customer/chat/mismatch/${mismatch.id}/decision`, payload, {
        skipLoader: true,
      })
      .then((res) => {
       
        window.location.href = res?.data?.checkoutUrl;
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      });
  };

  return (
    <ChatComponent
      onClose={onClose}
      title={"Chat with Driver"}
      messages={messages}
      onSend={addMessage}
    />
  );
}
